import createElement from '../logical-components/createElement';
import renderText from '../logical-components/renderText';
var generateMore = function () {
    var DOM = createElement('div');
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-card-more' },
    ]);
    // Candles sent
    wrapper.innerHTML += "<div class='mensenlinq-card-wide'>\n        ".concat(renderText('rememberMe.about.readMore'), "\n    </div>");
    // Pass the template back as a string
    DOM.appendChild(wrapper);
    return DOM.innerHTML;
};
export default generateMore;
